export const careEmail = "cx@homebound.com";
export const warrantyEmail = "warranty@homebound.com";
